import { useKeycloak } from "@react-keycloak/web";
import { Button } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import GrayRefreshIcon from "../../../assets/icons/GrayRefreshIcon";
import CustomTable from "../../../components/ui/CustomTable";
import Loader from "../../../components/ui/Loader";
import {
  useFirstTimeLoginMutation,
  useGetUserLogDataQuery,
} from "../../../features/portal/user/userApi";
import useError from "../../../hooks/useError";
import useTable from "../../../hooks/useTable";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { GetUserLogDataDataType } from "../../../types/portal/user";
import { addKeyInArray } from "../../../utils/utils";
import UserInfo from "./UserInfo";

export default function Settings() {
  const { keycloak } = useKeycloak();
  const [refreshing, setRefreshing] = useState(false);
  const { page, limit, handlePagination, handleLimit } = useTable();
  const { id } = useParams();
  const { data, isLoading, isError, error, refetch } = useGetUserLogDataQuery({
    params: {
      skip: undefined,
      page,
      limit,
    },
  });
  useError(isError, error, "Get user log data fail");
  const [
    firstTimeLogin,
    {
      isLoading: isFirstTimeLoginLoading,
      isError: isFirstTimeLoginError,
      error: firstTimeLoginError,
      data: firstTimeLoginData,
    },
  ] = useFirstTimeLoginMutation();
  useError(
    isFirstTimeLoginError,
    firstTimeLoginError,
    "Connected to server failed"
  );

  useEffect(() => {
    if (keycloak?.tokenParsed?.email) {
      firstTimeLogin({
        email: keycloak?.tokenParsed?.email,
      });
    }
  }, [firstTimeLogin, keycloak?.tokenParsed?.email]);

  useEffect(() => {
    if (firstTimeLoginData?.data?.user?.is_account_hold) {
      toast.warning(
        "Account not verified. Ask your admin to verify your account to continue."
      );
    }
  }, [firstTimeLoginData?.data?.user?.is_account_hold]);

  const leaveSettingsTabList = [
    {
      label: "User Info",
      link: `/admin/user-info`,
    },
    {
      label: "Change Password",
      link: `/admin/change-password`,
    },
  ];

  const columns: ColumnsType<GetUserLogDataDataType> = [
    {
      title: "Type",
      dataIndex: "type",
      render: (text: string) =>
        text.charAt(0).toUpperCase() + text.slice(1).toLowerCase(),
    },
    {
      title: "IP Address",
      dataIndex: "ipAddress",
    },
    {
      title: "Time",
      dataIndex: "timeBangladesh",
    },
  ];

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await refetch();
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <>
      <SidebarLayout
        title="Settings"
        tabList={leaveSettingsTabList}
        backLink="/admin/dashboard"
      >
        {isFirstTimeLoginLoading ? (
          <Loader />
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 pt-4 pb-4">
            {/* Left Section */}
            <div className="space-y-4">
              <UserInfo />
            </div>
            {/* Right Section */}
            <div className="lg:col-span-2 space-y-4">
              {/* <div className="py-4 mt-8 flex justify-center">
              <DocumentIcon />
            </div> */}

              {/* <Card>
              <div className="self-stretch justify-center text-slate-500 text-xl font-semibold mb-6">
                Access Log
              </div>
              <div className="mt-1 space-y-4">
                {logs.map((log, index) => (
                  <div key={index} className="relative pl-6">
                    {index !== logs.length - 1 && (
                      <div className="absolute left-2 top-5 w-0.5 h-full border-l-2 border-[#AFBACA] border-dashed"></div>
                    )}

                    <div
                      className={`absolute left-0 w-4 h-4 rounded-full ${
                        statusColors[log.status]
                      }`}
                    ></div>

                    <div className="text-[12px] ml-3">
                      <div className="font-semibold text-gray-600 text-[#C19C60]">
                        {log.time} - {log.date}
                      </div>
                      <p className="text-gray-700 text-display-body text-sm mb-1">
                        {log.message}
                      </p>
                      <div className="text-blue-500  flex items-center">
                        <div className="flex items-center gap-2">
                          <span className="text-[#FE7235] w-4 h-4 inline-flex items-center justify-center">
                            <UserIcon />
                          </span>
                          <span className="text-nowrap italic text-[#8897AE]">
                            {log.user} -{" "}
                          </span>
                        </div>
                        <span className="font-medium text-gray-600 ml-1 text-nowrap italic text-[#8897AE]">
                          {log.role}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Card> */}

              <CustomTable
                tableTitle="Access Log"
                loading={isLoading || refreshing}
                limit={limit}
                page={page}
                columns={columns}
                total={data?.data?.total}
                dataSource={addKeyInArray(data?.data?.logs)}
                handleLimit={handleLimit}
                handlePagination={handlePagination}
                filterSection={
                  <>
                    <Button
                      onClick={handleRefresh}
                      icon={<GrayRefreshIcon />}
                      size="small"
                      className="action-button"
                      danger
                    />
                  </>
                }
              />
            </div>
          </div>
        )}
      </SidebarLayout>
    </>
  );
}

interface LeaveDataType {
  key: string;
  loginTime: string;
  logoutTime: string;
  IpAdress: string;
}

const datas: LeaveDataType[] = [
  {
    key: "1",
    loginTime: "2024-02-05 14:01:35",
    logoutTime: "2024-02-05 14:02:48",
    IpAdress: "10.10.100.40	",
  },
  {
    key: "2",
    loginTime: "2024-02-05 14:01:35",
    logoutTime: "2024-02-05 14:02:48",
    IpAdress: "10.10.100.40	",
  },
  {
    key: "3",
    loginTime: "2024-02-05 14:01:35",
    logoutTime: "2024-02-05 14:02:48",
    IpAdress: "10.10.100.40	",
  },

  {
    key: "4",
    loginTime: "2024-02-05 14:01:35",
    logoutTime: "2024-02-05 14:02:48",
    IpAdress: "10.10.100.40	",
  },
];

const statusColors = {
  success: "bg-green-500",
  warning: "bg-yellow-400",
  error: "bg-red-500",
};

interface LogItem {
  time: string;
  date: string;
  message: string;
  user: string;
  role: string;
  status: "success" | "warning" | "error";
}

const logs: LogItem[] = [
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "This Business Activated Successfully!",
    user: "Md Abdul Hamid",
    role: "System Admin",
    status: "success",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "Request to Active This Business",
    user: "Md Abdul Hamid",
    role: "Finance Admin",
    status: "warning",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "This Business Inactivated Successfully!",
    user: "Md Abdul Hamid",
    role: "System Admin",
    status: "error",
  },
  {
    time: "06:01 PM",
    date: "06 Nov, 2024",
    message: "Request to Inactive This Business",
    user: "Md Abdul Hamid",
    role: "Business Team",
    status: "warning",
  },
];
